// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"M_TheComp___oi4R"};